module.exports = __webpack_public_path__ + "ffc916f97f371e80a621cc2b4ed53ec9.pdf";